import {Model} from './model';

export class Application implements Model {
  applicationId: number;
  clientRepresentativeId: number;
  source: string;
  tupasAuthId: string;
  ipAddress: string;
  created: Date;
  submitId: string;

  static copy(oldObj: Application): Application {
    const newObj = new Application();
    newObj.applicationId = oldObj.applicationId;
    newObj.clientRepresentativeId = oldObj.clientRepresentativeId;
    newObj.source = oldObj.source;
    newObj.tupasAuthId = oldObj.tupasAuthId;
    newObj.ipAddress = oldObj.ipAddress;
    newObj.created = oldObj.created;
    newObj.submitId = oldObj.submitId;
    return newObj;
  }

  public getPrimaryKey(): number {
    return this.applicationId;
  }

  isNew(): boolean {
    return isNaN(this.applicationId);
  }

  clone(): Application {
    return Application.copy(this);
  }
}
